import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  author?: IGatsbyImageDataObject
  iPad?: IGatsbyImageDataObject
}
function PatternAbout(props: Props) {
  const { author, iPad } = props

  return (
    <>
      <div className='pt-12 pb-2 et-grid-basic lg:grid-rows-[auto_1fr] lg:gap-y-0 bg-cream-200'>
        <h2 className='relative col-span-2 col-start-2 z-2 section-h2 font-sentinel__SemiBoldItal md:row-start-1 md:col-start-6 md:col-span-7 xl:mt-20'>Hey! I'm Teela</h2>

        {/* IMAGE */}
        {author && <div className='col-span-2 col-start-2 px-8 pt-8 md:row-start-1 md:col-start-2 md:col-span-6 md:row-span-2 md:ml-[-100px] lg:ml-[0px]'>
          <GatsbyImage
            className='relative md:left-[-25px] lg:left-[-50px]'
            image={author.gatsbyImageData}
            alt="Teela working on Procreate Patterns on the iPad" />
        </div>}

        <div className='col-span-2 col-start-2 md:col-start-7 md:col-span-7 md:row-start-2'>
          <h3 className='my-4 text-2xl'>and since 2014, my mission has been to make it easy for anyone to create beautiful digital art, no matter their skill level.
          </h3>
          <p className='mb-4 text-lg xl:ml-8'>
            To date, I've helped over 250k creatives build upon their digital skills and my tutorials on YouTube have accumulated over 22 million views.
          </p>
          <p className='text-lg xl:ml-8'>
            Pattern making has always been an enormous passion of mine, but the frustrations of creating them within Procreate were constant. Not having a pattern preview tool or a reliable Procreate process always discouraged me from creating more. My love of patterns won out, though, and I knew this was a problem worth solving.
          </p>
        </div>
      </div>

      {/* IMAGE #2 */}
      <div className='et-grid-basic md:pt-12 lg:pb-12 bg-cream-200'>

        {/* IMAGE */}
        {iPad && <div className='col-span-2 col-start-2 px-8 pt-2 pb-5 md:row-start-1 md:col-start-7 md:col-span-8 md:-rotate-12'>
          <div className='relative md:right-[-50px] lg:top-[-100px] lg:absolute lg:w-[500px] lg:right-0 xl:w-[600px] xl:top-[-200px] xl:rotate-12 xl:right-[50px] xxlg:right-[200px]'>
            <GatsbyImage
              image={iPad.gatsbyImageData}
              alt="Teela working on Procreate Patterns on the iPad" />
          </div>
        </div>}

        <div className='col-span-2 col-start-2 md:row-start-1 md:col-start-2 md:col-span-7 lg:col-start-2 lg:col-span-6'>
          <p className='mb-4 text-lg'>
            This is why we developed our own unique pattern previewer: The Pattern Playground. And this is why we developed a reliable, non-destructive process, delivering perfectly seamless patterns (no matter the pattern type!) every single time.
          </p>

          <p className='mb-4 text-lg'>
            The output ability... has been mind blowing. I knew this was going to speed up the process, but whoa. If I wasn't sitting in the front row, I would think it was unbelievable.
          </p>

          <p className='mb-4 text-lg'>
            You can make any seamlessly repeating pattern you want in a matter of minutes. <span className='italic'>Really.</span>
          </p>

          <p className='mb-4 text-lg'>
            Using <span className='italic'>Procreate</span>.
          </p>

          <p className='text-lg font-bold '>
            And I'll show you exactly how.
          </p>
        </div>
      </div>
    </>
  )
}

export default PatternAbout
